import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Apollo } from 'apollo-angular';
import { FILTER_PAYMENT_STATUS } from 'src/app/graphql/paymentStatus.graphql';

@Injectable({
  providedIn: 'root',
})
export class AccessBlockerService {
  constructor(private apollo: Apollo) {}

  /**
   * Subject utilizado para manipular quando o card de indimplência será "chacoalhado"
   * **/
  private triggerShakeSubject = new Subject<boolean>();
  public triggerShakeSubject$ = this.triggerShakeSubject.asObservable();

  /**
   * Método que atualiza o valor do subject que chacoalha o card de indimplência
   * **/
  public shakeCard() {
    this.triggerShakeSubject.next(true);
  }

  /**
   * Método que retorna o status de pagamento por empresa
   *  **/
  public getPaymentStatus(companiesIds: string | null) {
    return this.apollo.query({
      query: FILTER_PAYMENT_STATUS,
      fetchPolicy: 'no-cache',
      variables: {
        companiesIds,
      },
    });
  }
}
